const RewardIcon = ({ fill = '#fff' }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.988 4C9.364 4 4 9.376 4 16C4 22.624 9.364 28 15.988 28C22.624 28 28 22.624 28 16C28 9.376 22.624 4 15.988 4ZM24.964 12.592L18.952 12.076L16.552 6.424C20.404 6.652 23.644 9.148 24.964 12.592ZM18.88 20.104L16 18.376L13.132 20.104L13.888 16.84L11.356 14.644L14.692 14.356L16 11.272L17.308 14.344L20.644 14.632L18.112 16.828L18.88 20.104ZM15.448 6.424L13.048 12.088L7.024 12.604C8.344 9.148 11.584 6.64 15.448 6.424ZM6.4 16C6.4 15.232 6.496 14.488 6.676 13.768L11.224 17.704L9.892 23.404C7.756 21.64 6.4 18.976 6.4 16ZM11.008 24.184L16 21.172L20.992 24.172C19.528 25.072 17.824 25.6 15.988 25.6C14.164 25.6 12.46 25.072 11.008 24.184ZM22.108 23.404L20.776 17.704L25.324 13.768C25.492 14.476 25.6 15.232 25.6 16C25.6 18.976 24.232 21.64 22.108 23.404Z"
        fill={fill}
      />
    </svg>
  );
};
export default RewardIcon;
